import Accordion from '01_core/components/layout/Accordion';
import ListTable from '01_core/components/layout/module/ListTable';
import CButton from '01_core/components/materials/CButton';
import CMultiToggle from '01_core/components/materials/CMultiToggle';
import ListIconButton from '01_core/components/materials/ListIconButton';
import { withCallAPI } from '01_core/components/system/CallAPI';
import { withCodeUtil } from '01_core/components/system/CodeUtil';
import { withRouter } from '01_core/components/system/CustomRouter';
import { GROUPHISAI_HOMELIST, STATUS } from '01_core/constants/APIs';
import { LABEL } from '01_core/constants/labelConsts';
import dateUtil from '01_core/logics/dateUtil';
import storageUtil from '01_core/logics/storageUtil';
import stringUtil from '01_core/logics/stringUtil';
import moment from 'moment';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import withResponsive from '01_core/hooks/withResponsive';

import { HOME_DATA_KEY, PERMISSION_KEY, TYPES, homeActions } from '../homeActions';
import { styles } from '../styles';
import NewInfo, { checkNewInfo } from './NewInfo';

const stylesFromTheme = (theme) => (typeof styles === 'function' ? styles(theme) : styles);
const StyledAccordionButton = styled(CButton)(({ theme }) => stylesFromTheme(theme).accordionButton || {});
const StyledTextEllipsis = styled(Typography)(({ theme }) => stylesFromTheme(theme).textEllipsis || {});
const StyledGrouphisaiToggleButton = styled(CMultiToggle)(({ theme }) => stylesFromTheme(theme).grouphisaiToggleButton || {});

export class GrouphisaiInfoField extends React.Component {
  constructor(props) {
    super(props);
    props.displayContents(false);
  }

  componentDidMount = (prevProps) => {
    const { callAPI, setHomeData, displayContents } = this.props;
    const defSearchStartDt = this.getDefaultSearchDt();
    const GrouphisaiSendData = {
      srhStartDt:  defSearchStartDt,
      hisaiKbnCd: [],
      applyHomeDisplaySetting: true,
    };
    
    displayContents(false);
    callAPI(GROUPHISAI_HOMELIST, GrouphisaiSendData).then((response) => {
      if (response.status === STATUS.SUCCESS && response.data.length > 0) {
        const grouphisai = {};
        const rootList = [];
        response.rootKbnList.forEach((item) => {
          grouphisai[item.grouphisaiKbnCd] = [];
        });

        response.data.forEach((item) => {
          grouphisai[item.rootKbn].push(item);
        });
        setHomeData(HOME_DATA_KEY.GROUPHISAI_DATA, grouphisai);

        response.rootKbnList.forEach((item) => {
          if (!(grouphisai[item.grouphisaiKbnCd].length === 0)) {
            rootList.push({
              displayName: item.grouphisaiKbnName.replace('【', '').replace('】', ''),
              value: item.grouphisaiKbnCd,
            });
          }
        });

        setHomeData(HOME_DATA_KEY.GROUPHISAI_KBN_DATA, rootList);
        setHomeData(HOME_DATA_KEY.GROUPHISAI_KBN_SELECT_DATA, this.getSelectedRootKbn(rootList, this.props.rootKbn));
        displayContents(true);
      } else {
        setHomeData(HOME_DATA_KEY.GROUPHISAI_DATA, []);
        setHomeData(HOME_DATA_KEY.GROUPHISAI_KBN_DATA, []);
        setHomeData(HOME_DATA_KEY.GROUPHISAI_KBN_SELECT_DATA, '');
      }
    });
  }

  getDefaultSearchDt = () => {
    return moment()
      .subtract(this.props.systemSettings.common_home_display_past_days, 'days')
      .format(dateUtil.DATETIME_FORMAT);
  };

  getSelectedRootKbn = (rootList, rootKbn) => {
    let selectRootKbn = '';
    if (!rootList || rootList.length === 0) {
      return selectRootKbn;
    }

    let selectedIndex = 0;
    rootList.forEach((item, index) => {
      if (rootKbn === item.value) {
        selectedIndex = index;
        return;
      }
    });

    return rootList[selectedIndex].value;
  };

  onSettingDisplayClick = () => {
    this.props.history.push({
      pathname: '/usercustom_home_display_setting',
      state: {
        displayUnit: '2',
      },
    });
  };

  onSearchClick = () => {
    this.props.history.push('/grouphisai_search');
  };

  onRegisterClick = () => {
    this.props.history.push('/grouphisai_register');
  };

  onDetailClick = (data) => {
    const { grouphisaiNo, grouphisaiKbnCd, regDt } = data;
    storageUtil.setReferencedDetailDt(storageUtil.storageKeyPrefix.GROUPHISAI + grouphisaiKbnCd, regDt);

    this.props.history.push({
      pathname: '/grouphisai_search',
      state: { grouphisaiNo: grouphisaiNo, content: 'detail' },
    });
  };

  onHistoryClick = (grouphisaiKbnCd, grouphisaiKbnName) => {
    this.props.history.push({
      pathname: '/grouphisai_search',
      state: { grouphisaiKbnCd: grouphisaiKbnCd, grouphisaiKbnName: grouphisaiKbnName, content: 'history' },
    });
  };

  handleSelectOption = (value) => {
    this.props.setHomeData(HOME_DATA_KEY.GROUPHISAI_KBN_SELECT_DATA, value);
  };

  isShowContents = () => {
    const { width } = this.props;

    switch (width) {
      case 'xs':
        return false;
      case 'sm':
        return false;
      default:
        return true;
    }
  };

  render() {
    const { intl, systemSettings, grouphisai, rootKbnList, rootKbn, permission, language } = this.props;

    let settingDisplayButton = (
      <StyledAccordionButton
        component="span"
        onClick={(e) => {
          e.stopPropagation();
          this.onSettingDisplayClick();
        }}
      >
        {intl.formatMessage({ id: LABEL.CORE_SETTING_DISPLAY })}
      </StyledAccordionButton>
    );

    let searchButton = (
      <StyledAccordionButton
        component="span"
        onClick={(e) => {
          e.stopPropagation();
          this.onSearchClick();
        }}
      >
        {intl.formatMessage({ id: LABEL.CORE_SEARCH })}
      </StyledAccordionButton>
    );

    let registerButton = (
      <StyledAccordionButton
        component="span"
        onClick={(e) => {
          e.stopPropagation();
          this.onRegisterClick();
        }}
      >
        {intl.formatMessage({ id: LABEL.CORE_REGISTER })}
      </StyledAccordionButton>
    );

    let contentWidth = this.isShowContents() ? 200 : 0;
    let columns = [
      {
        dataKey: 'detailIcon',
        label: intl.formatMessage({ id: LABEL.CORE_DETAIL }),
        width: 42,
        minWidth: 42,
        maxWidth: 42,
        headerStyle: {
          textAlign: 'center',
          paddingLeft: 0,
          color: 'text.secondary',
          whiteSpace: 'normal',
          wordBreak: 'break-word',
        },
        cellStyle: {
          textAlign: 'center',
          paddingLeft: 0,
        },
      },
      {
        dataKey: 'historyIcon',
        label: intl.formatMessage({ id: LABEL.CORE_HISTORY }),
        width: 42,
        minWidth: 42,
        maxWidth: 42,
        headerStyle: {
          textAlign: 'center',
          paddingLeft: 0,
          color: 'text.secondary',
          whiteSpace: 'normal',
          wordBreak: 'break-word',
        },
        cellStyle: {
          textAlign: 'center',
          paddingLeft: 0,
        },
      },
      {
        dataKey: 'hisaiKbn',
        label: intl.formatMessage({ id: LABEL.CORE_POST }),
        width: 100,
        minWidth: 1,
        maxWidth: contentWidth > 0 ? 300 : undefined,
        flexGrow: 1,
        headerStyle: {
          color: 'text.secondary',
        },
      },
      {
        dataKey: 'subject',
        label: intl.formatMessage({ id: LABEL.GROUPHISAI_SUBJECT }),
        width: contentWidth,
        minWidth: contentWidth > 0 ? 1 : 0,
        flexGrow: contentWidth > 0 ? 1 : 0,
        headerStyle: {
          color: 'text.secondary',
        },
      },
      {
        dataKey: 'registerDt',
        label: intl.formatMessage({ id: LABEL.CORE_REGISTERED_DATE }),
        width: 80,
        minWidth: 80,
        maxWidth: 80,
        headerStyle: {
          color: 'text.secondary',
          whiteSpace: 'normal',
          wordBreak: 'break-word',
        },
      },
    ];

    const createRow = (n) => {
      const detailIcon = n.grouphisaiNo ? (
        <ListIconButton
          action='detail'
          onClick={() => {
            this.onDetailClick(n);
          }}
        />
      ) : null;
      const historyIcon = n.hasHistory ? (
        <ListIconButton
          action='history'
          onClick={() => {
            this.onHistoryClick(n.grouphisaiKbnCd, n.grouphisaiKbnName);
          }}
        />
      ) : null;
      const newInfoState = n.grouphisaiNo
        ? checkNewInfo(
            n.regDt,
            n.grouphisaiKbnCd,
            storageUtil.storageKeyPrefix.GROUPHISAI,
            this.props.systemSettings.common_home_new_info_past_days,
          )
        : false;
      const hisaiKbn = (
        <StyledTextEllipsis>
          <NewInfo isDisplay={newInfoState} />
          {stringUtil.emptyToHyphen(n.grouphisaiKbnName)}
        </StyledTextEllipsis>
      );
      const subject = n.subject ? (
        <StyledTextEllipsis>{stringUtil.emptyToHyphen(n.subject)}</StyledTextEllipsis>
      ) : (
        <div>
          <StyledTextEllipsis>
            {intl.formatMessage({ id: LABEL.COMMON_NO_INFO }, { 0: systemSettings.common_home_display_past_days })}
          </StyledTextEllipsis>
        </div>
      );
      const registerDt = dateUtil.fromNow(stringUtil.emptyToHyphen(n.regDt), language);

      return { detailIcon, historyIcon, newInfoState, hisaiKbn, subject, registerDt };
    };

    return (
      <React.Fragment>
        <Accordion
          title={intl.formatMessage({ id: LABEL.USERCUSTOM_GROUP_HISAI })}
          buttons={[
            settingDisplayButton,
            searchButton,
            permission[PERMISSION_KEY.GROUPHISAI_REGISTER] ? registerButton : null,
          ]}
        >
          {rootKbnList.length > 1 ? (
            <StyledGrouphisaiToggleButton
              options={rootKbnList}
              selectedOption={rootKbn}
              onSelectOption={this.handleSelectOption}
            />
          ) : null}
          <ListTable
            rowData={grouphisai[rootKbn] ? grouphisai[rootKbn] : []}
            autoWidth
            height={280 - (rootKbnList.length > 1 ? 32 : 0)}
            headerHeight={45}
            {...{ columns, createRow }}
          />
        </Accordion>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    systemSettings: state.coreLoginInfo.systemSettings,
    grouphisai: state.home.homeData[HOME_DATA_KEY.GROUPHISAI_DATA]
      ? state.home.homeData[HOME_DATA_KEY.GROUPHISAI_DATA]
      : [],
    rootKbnList: state.home.homeData[HOME_DATA_KEY.GROUPHISAI_KBN_DATA]
      ? state.home.homeData[HOME_DATA_KEY.GROUPHISAI_KBN_DATA]
      : [],
    rootKbn: state.home.homeData[HOME_DATA_KEY.GROUPHISAI_KBN_SELECT_DATA]
      ? state.home.homeData[HOME_DATA_KEY.GROUPHISAI_KBN_SELECT_DATA]
      : '001',
    permission: state.home.permission,
    language: state.coreLocale.language,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setHomeData: (fid, data) => dispatch(homeActions[TYPES.SET_HOME_DATA](fid, data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withResponsive(withRouter(injectIntl(withCallAPI(withCodeUtil(GrouphisaiInfoField))))));